function normalizeText(value) {
  return String(value || "").trim();
}

export function normalizeContactLookupValue(value) {
  const rawValue = normalizeText(value);

  if (!rawValue) {
    return "";
  }

  const idWithoutDomain = rawValue.includes("@")
    ? rawValue.split("@")[0]
    : rawValue;
  const numberLike = idWithoutDomain.replace(/[^\d*#]/g, "");

  return numberLike || idWithoutDomain.toLowerCase();
}

export function extractContactNumbers(contact = {}) {
  return [
    contact?.offEXtn,
    contact?.extension,
    contact?.number,
    contact?.phone,
    contact?.mobile,
    contact?.extn,
    contact?.userName,
    contact?.userId,
    contact?.userType,
  ]
    .map((value) => normalizeText(value))
    .filter(Boolean);
}

export function buildContactLookup(contacts = []) {
  const lookup = new Map();

  contacts.forEach((contact) => {
    const designation = normalizeText(contact?.designation);
    const name = normalizeText(contact?.name);

    extractContactNumbers(contact).forEach((number) => {
      const key = normalizeContactLookupValue(number);

      if (!key) {
        return;
      }

      const previous = lookup.get(key);

      if (!previous) {
        lookup.set(key, {
          designation,
          name,
          number,
          raw: contact,
        });
        return;
      }

      lookup.set(key, {
        designation: previous.designation || designation,
        name: previous.name || name,
        number: previous.number || number,
        raw: previous.raw || contact,
      });
    });
  });

  return lookup;
}

export function resolveContactIdentityByNumber(lookup, value) {
  const number = normalizeText(value);
  const lookupKey = normalizeContactLookupValue(number);
  const resolved = lookupKey ? lookup?.get?.(lookupKey) : null;
  const designation = normalizeText(resolved?.designation);
  const name = normalizeText(resolved?.name);
  const isNumberLike = /[\d*#]/.test(number);

  const displayName =
    designation ||
    name ||
    (number
      ? isNumberLike
        ? `Unknown - ${number}`
        : number
      : "Unknown");
  const displayWithNumber =
    designation || name
      ? number
        ? `${displayName} `
        : displayName
      : displayName;

  return {
    number,
    designation,
    name,
    displayName,
    displayWithNumber,
    matchedContact: resolved?.raw || null,
  };
}
